import { render, staticRenderFns } from "./bankCardBindingTwice.vue?vue&type=template&id=c394012e&scoped=true"
import script from "./bankCardBindingTwice.vue?vue&type=script&lang=js"
export * from "./bankCardBindingTwice.vue?vue&type=script&lang=js"
import style0 from "./bankCardBindingTwice.vue?vue&type=style&index=0&id=c394012e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c394012e",
  null
  
)

export default component.exports